import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  root: {
    width: spacing(100),
    marginTop: spacing(8),
  },
  btn: {
    marginTop: spacing(6),
  },
});

export default styles;
